import profile from "common//icons/testimonial/profile.svg";
import profile2 from "common/icons/testimonial/profile2.svg";

export const StartUps = [
  {
    name: "Start ups",
    no: 2,
  },
  {
    name: "US Patents",
    no: 21,
  },
  {
    name: "Papers",
    no: 50,
  },
];

export const testimonials = [
  {
    id: 1,
    text: "Deva is a friend, philosopher and mentor to me. An absolutely zero bullshit person with very high level of integrity and very vivid first hand understanding of Business in Technology. He acts as my sounding board and coach. Given the challenges of running a startup, having someone like Deva by my side gives me great strength.",
    author: "Ganesh Shankar",
    title: "Founder and CEO, FluxGen Technologies",
    image: profile,
  },
  {
    id: 2,
    text: "For anyone looking for an extremely smart mind who is brutally honest with his opinions for some refreshing advice, I would highly recommend Deva. With huge experience in IoT and machine learning technologies and his no-bullshit approach, Deva has definitely saved us months of futile efforts putting us onto path of high impact based actions. His understanding of the energy market allows him to come up with insights on product design, market entry strategy and the commercial viability within no time.",
    author: "- Aditya Bhatt",
    title: "Co-founder and CEO, Airprobe.in",
    image: profile2,
  },
  {
    id: 3,
    text: "Our Product Development Coach introduced us to Deva to review our product architecture and engage in dialogues with our team to help resolve key product related questions. We found him to be a very insightful person who, though reticent, successfully gets to the heart of the issue. Our team picked up some good learnings from Deva’s rich experience in one day of interaction.",
    author: "Arjun Gupta",
    title: "Founder and CEO, SmartJoules",
    image: profile,
  },
];

export const recognitionsData = [
  {
    id: 1,
    text: "Recognized as an IoT thought leader by India IoT Congress, 2017.",
  },
  { id: 2, text: "Recognized paper award at ACM e-Energy 2014." },
  { id: 3, text: "Recognized paper award at ACM Buildsys 2014." },
  { id: 4, text: "Recognized talk at IoT Summit, 2018." },
  { id: 5, text: "Panel discussion on Smart Grids, 2019." },
  { id: 6, text: "Recognized lecture at a top university, 2020." },
];

export const talksData = [
  {
    id: 101,
    text: "Distributed Energy Networks Panel Discussion, ACM e-Energy, July 2015",
  },
  {
    id: 102,
    text: "“Real-time contingency analysis”, US-India HPC workshop, IISc, Dec 2013.",
  },
  {
    id: 103,
    text: "“Active RFID technologies”, IdTechEx RFID Summit, Nov 2005.",
  },
  { id: 104, text: "Keynote at Cloud Summit, 2017." },
  { id: 105, text: "Invited talk at XYZ Conference, 2019." },
  {
    id: 106,
    text: "Distinguished Speaker Talk, Virtual Tech Conference, 2021.",
  },
];
